import React from "react";

const FileList = ({ files, setDownloadFileData }) => {

  return (
    <div>
      <div>
        {files.map((file, index) => (
          <div key={index} className="flex items-center justify-between mb-2 bg-[#F2F2F2] p-3 rounded-md">
            <span>{file.nomeOriginal}</span>
            <button
              type="button"
              onClick={() => setDownloadFileData(file)}
              className="bg-[#034EA2] w-[40px] h-[40px] rounded-[3px] flex items-center justify-center"
            >
              <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15"
                    stroke="#ffffff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                  <path
                    d="M12 3V16M12 16L16 11.625M12 16L8 11.625"
                    stroke="#ffffff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>{" "}
                </g>
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileList;
